import(/* webpackMode: "eager" */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/CoursesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/GallerySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/RegistrationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/u415329742/domains/zenyoga.institute/hbuilds/source/src/components/TopBar.tsx");
